import styled from 'styled-components';
import { Icon, IconName, IconSize } from '@ardoq/icons';

const ModalInlineIconStyle = styled(Icon)`
  display: inline;
  vertical-align: middle;
`;

const ModalInlineIcon = ({ iconName }: { iconName: IconName }) => (
  <ModalInlineIconStyle iconName={iconName} iconSize={IconSize.SMALL} />
);

export { ModalInlineIcon };
